import React, { createContext, Dispatch, PropsWithChildren, useContext, useEffect, useReducer } from "react";
import { matchRoutes, useSearchParams } from "react-router-dom";
import { useLocaleContext, useLocaleUrl } from "@ct-react/locale";
import { AccommodationType } from "@shared/models/article";
import { parseQuerySearchParams } from "../utils/search-params";
import { AnySearchInput } from "../models/search";
import { searchRoutes } from "../routes";

type State = { [key in AccommodationType]: any; };

const initialState = {
  [AccommodationType.RENTAL]: {},
  [AccommodationType.SEASONAL]: {},
  [AccommodationType.ANNUAL]: {},
  [AccommodationType.SALE]: {},
};

const SearchContext = createContext<[ State, Dispatch<any> ]>([ initialState, () => {} ]);

const reducer = (state: State, action: { type: AccommodationType, payload: AnySearchInput }): State => {
  switch (action.type) {
    default:
      return  { ...state, [action.type]: action.payload };
  }
}

export const useSearchContext = () => {
  const context = useContext(SearchContext);
  if (!context) throw new Error("useSearchContext must be used within a SearchProvider");
  return context;
}

export const SearchProvider = ({ children }: PropsWithChildren) => {

  const { locale } = useLocaleContext();
  const { currentUrl } = useLocaleUrl();
  const [ searchParams ] = useSearchParams();
  const [ state, dispatch ] = useReducer(reducer, initialState);

  // retrieve search params on loading
  useEffect(() => {
    const match = (matchRoutes(searchRoutes(false), currentUrl, `/${locale.basename}`)?.filter(r => r.route.index) || [])
      .flatMap(r => r.route).find(r => !!(r.element as any)?.props.type);
    if (!match) return;

    const type = (match!.element as any).props.type as AccommodationType
    const payload = parseQuerySearchParams(searchParams, type);
    dispatch({ type, payload });
  }, []);

  return (<SearchContext.Provider value={[ state, dispatch ]}>{children}</SearchContext.Provider>);

}
